/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { styled } from "styled-components";
import InputText from "../Text/InputText";
import Label from "../Text/Label";
import { Edit } from "../../icons";
import { Button } from "../Button";
import Colors from "../../styles/Colors";
import media from "../../styles/mediaQueries";
import rem from "../../utils/rem";
import useWindowWidth, { WindowWidth } from "../../hooks/useWindowWidth";
const StyledEditInput = styled.div `
  position: relative;
`;
const StyledEditInputButton = styled.button `
  background-color: transparent;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  appearance: none;
  border: none;
  padding: 0;
  color: ${(props) => (props.disabled ? Colors.GRAY : Colors.GRAY_DARKEST)};
  outline: none;
  &:hover {
    cursor: ${(props) => (props.disabled ? "auto" : "pointer")};
  }

  &:hover + div,
  &:focus + div {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25),
      inset 0 0 0 1px ${Colors.GRAY_DARK};
  }
  > button.editbtn,
  > span.editbtn {
    position: absolute;
    top: ${rem(16)};
    right: ${rem(16)};
    ${media.down("small") `
      top: ${rem(8)};
      right: ${rem(8)};
    `}
  }
`;
const StyledEditInputContent = styled.div `
  background-color: ${Colors.WHITE};
  color: ${Colors.TEXT};
  border-radius: 5px;
  padding: ${rem(40)} ${rem(30)};
  box-shadow: inset 0 0 0 1px ${Colors.GRAY};
  pointer-events: none;
  min-height: 85px;
  ${media.down("belowMedium") `
    padding: ${(props) => `${rem(24)} ${rem(16)} ${props.hasImage ? rem(16) : ""}`};
  `}
`;
const EditInputContent = styled.div `
  display: flex;
  flex-direction: ${(props) => props.flexDirection ?? "column"};
  justify-content: flex-start;
  align-items: flex-start;
  ${media.down("small") `
    flex-direction: column;
  `}
  > div:not(:last-child) {
    margin-bottom: ${rem(12)};
  }
`;
const EditInputContentImage = styled.img `
  display: block;
  border-radius: 5px;
  width: auto;
  margin-right: 2rem;
  max-width: 100%;
  ${media.down("belowMedium") `
    margin-right: 1rem;
  `}
  ${media.down("small") `
    margin-right: 0;
    margin-top: ${rem(12)};
  `}
`;
const EditInputContentText = styled.div `
  width: 100%;
  > div {
    margin-bottom: 0.4rem;
  }
  h6 {
    margin-right: 1.5rem;
    ${media.down("small") `
      margin-right: 2rem;
    `}
  }
`;
const Header = styled.div `
  min-width: 240px;
  max-width: 280px;
  ${media.down("belowMedium") `
    min-width: 200px;
  `}
  margin-right: 2rem;
  img {
    margin-right: 0;
  }
  h2 {
    margin-top: 0;
    font-size: 1.25rem;
    font-weight: 500;
    svg {
      position: relative;
      bottom: -4px;
      margin-right: 1rem;
    }
  }
`;
const EdInputContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const PriceInfo = styled.div ``;
const TextLine = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const PendinSumContent = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: 500;
  border-top: 1px solid ${Colors.GRAY};
  margin-top: 1.25rem;
  padding-top: 1rem;
`;
export const EditInput = ({ header, texts, image, direction, disabled = false, pending, onClick, ...props }) => {
    const windowWidth = useWindowWidth();
    if (typeof windowWidth === "undefined")
        return null;
    const Icon = header && header.icon ? header.icon : null;
    const EditInputTexts = (React.createElement(EditInputContentText, null,
        texts.map(({ key, label, text, price }) => (React.createElement("div", { key: key || label },
            React.createElement(Label, { textColor: "TEXT", as: "h6", size: "medium" }, label),
            React.createElement(TextLine, null,
                text && React.createElement(InputText, { textColor: "TEXT" }, text),
                price && (React.createElement(PriceInfo, null,
                    new Intl.NumberFormat(price.locale, {
                        style: "currency",
                        currencyDisplay: "narrowSymbol",
                        currency: price.currency,
                    }).format(price.amount),
                    price.postfix && React.createElement("span", null, price.postfix))))))),
        pending && pending.price && (React.createElement(PendinSumContent, null,
            React.createElement("span", null, pending.label),
            React.createElement(PriceInfo, null,
                new Intl.NumberFormat(pending.price.locale, {
                    style: "currency",
                    currencyDisplay: "narrowSymbol",
                    currency: pending.price.currency,
                }).format(pending.price.amount),
                pending.price.postfix && React.createElement("span", null, pending.price.postfix)))),
        pending && !pending.price && React.createElement("span", null, pending.label)));
    return (React.createElement(StyledEditInput, null,
        !disabled && onClick ? (React.createElement(StyledEditInputButton, { ...props, onClick: (e) => onClick(e), disabled: disabled },
            React.createElement(Button, { tabIndex: -1, className: "editbtn", renderAs: "span", theme: "ghost", disabled: disabled, leadingIcon: Edit, title: "Edit" }))) : null,
        React.createElement(StyledEditInputContent, { hasImage: !!image, flexDirection: direction },
            React.createElement(EdInputContentWrapper, { hasButton: !!onClick }, windowWidth === WindowWidth.XSmall ? (React.createElement(React.Fragment, null,
                header && (React.createElement(Header, { hasImage: !!image },
                    React.createElement("h2", null,
                        Icon && React.createElement(Icon, { width: 24, height: 24 }),
                        header.title))),
                EditInputTexts,
                image && (React.createElement(EditInputContentImage, { src: image.src, alt: image.alt ? image.alt : "" })))) : (React.createElement(EditInputContent, { hasImage: !!image, flexDirection: direction },
                header && (React.createElement(Header, { hasImage: !!image },
                    React.createElement("h2", null,
                        Icon && React.createElement(Icon, { width: 24, height: 24 }),
                        header.title),
                    image && (React.createElement(EditInputContentImage, { src: image.src, alt: image.alt ? image.alt : header.title })))),
                image && !header && (React.createElement(EditInputContentImage, { src: image.src, alt: image.alt ? image.alt : "" })),
                EditInputTexts))))));
};
export default EditInput;
//# sourceMappingURL=EditInput.js.map